import { useDeviceType } from '@cian/ui-kit';
import React from 'react';
import cn from 'clsx';
import styles from './styles.css';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Основной лейаут футера. Футер растягивается на всю ширину своего родителя.
 */
export var FooterLayout = function FooterLayout(_ref) {
  var topSection = _ref.topSection,
    divider = _ref.divider,
    bottomSection = _ref.bottomSection,
    background = _ref.background,
    padding = _ref.padding,
    contentMaxWidth = _ref.contentMaxWidth,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? 'page-footer' : _ref$testId;
  var deviceType = useDeviceType();
  return /*#__PURE__*/_jsx("footer", {
    className: styles['container'],
    style: {
      background: background,
      padding: padding
    },
    "data-testid": testId,
    children: /*#__PURE__*/_jsxs("div", {
      className: cn(styles['content-wrapper'], styles[deviceType]),
      style: {
        maxWidth: contentMaxWidth
      },
      children: [topSection, divider, bottomSection]
    })
  });
};